import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "settings-bar__nextui-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.nextUiCapable)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "settings-bar__button settings-bar__nextui-indicator",
        title: _ctx.$t('settings.nextUi.indicatorTitle'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOpenModal && _ctx.handleOpenModal(...args)))
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.isNextUiPage
          ? _ctx.$t("settings.nextUi.enabled")
          : _ctx.$t("settings.nextUi.available")), 1)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}